import type { RouteObject } from 'react-router';
import { PublicLayout } from './Layout.tsx';
import { HomePage } from './pages/Home.tsx';
import { RulesPage } from './pages/Rules.tsx';
import { RegisterPage } from './pages/Register.tsx';
import { ResultsPage } from './pages/Results.tsx';
import { AboutPage } from './pages/About.tsx';
import { FindIdPage } from './pages/FindId.tsx';
import { NotFoundPage } from './pages/ErrorPage.tsx';

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'rules', element: <RulesPage /> },
      { path: 'register', element: <RegisterPage /> },
      { path: 'find-id', element: <FindIdPage /> },
      { path: 'results', element: <ResultsPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
